import React from 'react';

interface IUzivatele {}

const Uzivatele: React.FC<IUzivatele> = () => {
    return <></>;
};

export default Uzivatele;
